<template lang="html">
  <div :class="theClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    xs: {
      default: null,
    },
    sm: {
      default: null,
    },
    md: {
      default: null,
    },
    lg: {
      default: null,
    },
    xl: {
      default: null,
    },
  },
  computed: {
    theClass() {
      let c = 'col';

      if (this.xs) {
        c += ' col-' + this.xs;
      }
      if (this.sm) {
        c += ' col-sm-' + this.sm;
      }
      if (this.md) {
        c += ' col-md-' + this.md;
      }
      if (this.lg) {
        c += ' col-lg-' + this.lg;
      }
      if (this.xl) {
        c += ' col-xl-' + this.xl;
      }

      return c;
    },
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/parts/layout/col.vue